import React from 'react';
import PropTypes from 'prop-types';
import Breadcrumbs from '@saucelabs/sl-component-breadcrumbs';
import { Col } from '@saucelabs/sl-component-grid';

import Styles from './PerformanceNav.styles';

const PerformanceNav = ({ testId, isOnHistoryPage, pageIndex, routerSearchQuery }) => {
  const crumbsList = [{
    name: 'Test Details',
    url: {
      pathname: `/tests/${testId}`,
      search: routerSearchQuery,
    },
  }, {
    name: 'Performance Report',
    url: {
      pathname: `/performance/${testId}/${pageIndex}`,
      search: routerSearchQuery,
    },
  },
  {
    name: 'Performance History',
    url: {
      pathname: `/performance/${testId}/${pageIndex}/history`,
      search: routerSearchQuery,
    },
  }];

  return (
    <Col
      className={Styles['top-row']}
      sm={12}
      xs={12}
    >
      <Breadcrumbs list={isOnHistoryPage ? crumbsList : crumbsList.slice(0, 2)} />
    </Col>
  );
};

PerformanceNav.propTypes = {
  isOnHistoryPage: PropTypes.bool.isRequired,
  pageIndex: PropTypes.number.isRequired,
  routerSearchQuery: PropTypes.string,
  testId: PropTypes.string.isRequired,
};

PerformanceNav.defaultProps = {
  routerSearchQuery: '',
};

export default PerformanceNav;
